const FLOW_RECORDER_SESSION_STORAGE_KEY = 'flow-recorder-session-id'

export function getFlowRecorderSessionId() {
	if (typeof window === 'undefined') {
		return 'server'
	}

	let sessionId = window.sessionStorage.getItem(FLOW_RECORDER_SESSION_STORAGE_KEY)
	if (sessionId) {
		return sessionId
	}

	sessionId = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
		? crypto.randomUUID()
		: `${Date.now()}-${Math.random().toString(36).slice(2)}`

	window.sessionStorage.setItem(FLOW_RECORDER_SESSION_STORAGE_KEY, sessionId)
	return sessionId
}

export function hasRecordedFlowData(flow: FlowData | null | undefined) {
	return !!flow?.setup
		|| !!flow?.draftEvent
		|| !!flow?.events?.length
}

export function isFlowAuthor(props: {
	flow: FlowData | null | undefined
	userId?: UserId | null
	sessionId?: string | null
}) {
	const { flow, userId, sessionId } = props
	if (!flow) {
		return false
	}

	if (flow.authorUid) {
		return !!userId && flow.authorUid === userId
	}

	return !!sessionId && !!flow.authorSessionId && flow.authorSessionId === sessionId
}

export function canManageFlowData(props: {
	flow: FlowData | null | undefined
	isManager: boolean
	userId?: UserId | null
	sessionId?: string | null
}) {
	return props.isManager || isFlowAuthor(props)
}
